import * as React from 'react';
import cx from 'classnames';

import { CTX_ANNOUNCEMENT_STREAM, StreamContext } from 'chat/components/Stream';
import Buttons from 'components/Buttons';
import MediaObject from 'components/MediaObject';
import Text from 'components/Text';
import InfoButton from './AnnouncementMessageItemHeaderInfoButton';
import ExtraActionsButton from './AnnouncementMessageItemHeaderExtraActionsButton';
import './AnnouncementMessageItemHeader.scss';

export type Props = {
  avatar: React.ReactElement<any>;
  canViewDeliveryInformation: boolean;
  messageUuid: string;
  // @ts-expect-error ts-migrate(2304) FIXME: Cannot find name 'ReactionGQL'.
  reactions?: ReactionGQL[] | null;
  streamUuid: string;
  targetTitle: string;
  targetDescription?: string | null;
  urgent?: boolean;
};

const AnnouncementMessageItemHeader: React.FC<Props> = (props) => {
  const {
    avatar,
    canViewDeliveryInformation,
    messageUuid,
    reactions,
    streamUuid,
    targetTitle,
    targetDescription,
    urgent,
  } = props;
  const streamContext = React.useContext(StreamContext);

  const renderActionItems = () => {
    const infoButtonProps = {
      canViewDeliveryInformation,
      messageUuid,
      reactions,
      streamUuid,
      targetTitle,
      targetDescription,
    };

    if (canViewDeliveryInformation) {
      return (
        <Buttons margin="small">
          <InfoButton {...infoButtonProps} />
          {streamContext === CTX_ANNOUNCEMENT_STREAM && (
            <ExtraActionsButton
              messageUuid={messageUuid}
              streamUuid={streamUuid}
              groupName={targetTitle}
            />
          )}
        </Buttons>
      );
    }

    if (reactions && reactions.length) {
      return <InfoButton {...infoButtonProps} />;
    }

    return null;
  };

  return (
    <React.Fragment>
      <MediaObject
        center
        gutter="xxsmall"
        className={cx(
          'AnnouncementMessageItem-head',
          urgent && 'AnnouncementMessageItem-head--urgent'
        )}
      >
        {avatar}
        <MediaObject figure="right" center>
          <div className="AnnouncementMessageItem-head-classInfo">
            <Text weight="semibold" color="chalkboard" truncate>
              {targetTitle}
            </Text>
            <Text color="graphite" truncate>
              {targetDescription}
            </Text>
          </div>
          {/* The following cannot be rendered as a react component because of the inner workings of LayerTrigger */}
          {renderActionItems()}
        </MediaObject>
      </MediaObject>
    </React.Fragment>
  );
};

export default AnnouncementMessageItemHeader;
